import { render } from "./ClassJoinButton.vue?vue&type=template&id=20daa824&scoped=true"
import script from "./ClassJoinButton.vue?vue&type=script&lang=js"
export * from "./ClassJoinButton.vue?vue&type=script&lang=js"

import "./ClassJoinButton.vue?vue&type=style&index=0&id=20daa824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20daa824"]])

export default __exports__